export const COUNTRY_CURRENCY = Object.freeze({
  AC: "shp", AD: "eur", AE: "aed", AF: "afn", AG: "xcd", AI: "xcd", AL: "all", AM: "amd", AO: "aoa", AR: "ars",
  AS: "usd", AT: "eur", AU: "aud", AW: "awg", AX: "eur", AZ: "azn", BA: "bam", BB: "bbd", BD: "bdt", BE: "eur",
  BF: "xof", BG: "bgn", BH: "bhd", BI: "bif", BJ: "xof", BL: "eur", BM: "bmd", BN: "bnd", BO: "bob", BQ: "usd",
  BR: "brl", BS: "bsd", BT: "inr", BV: "nok", BW: "bwp", BY: "byn", BZ: "bzd", CA: "cad", CC: "aud", CD: "cdf",
  CF: "xaf", CG: "xaf", CH: "chf", CI: "xof", CK: "nzd", CL: "clp", CM: "xaf", CN: "cny", CO: "cop", CR: "crc",
  CU: "cup", CV: "cve", CW: "xcg", CX: "aud", CY: "eur", CZ: "czk", DE: "eur", DG: "usd", DJ: "djf", DK: "dkk",
  DM: "xcd", DO: "dop", DZ: "dzd", EA: "eur", EC: "usd", EE: "eur", EG: "egp", EH: "mad", ER: "ern", ES: "eur",
  ET: "etb", EU: "eur", FI: "eur", FJ: "fjd", FK: "fkp", FM: "usd", FO: "dkk", FR: "eur", GA: "xaf", GB: "gbp",
  GD: "xcd", GE: "gel", GF: "eur", GG: "gbp", GH: "ghs", GI: "gip", GL: "dkk", GM: "gmd", GN: "gnf", GP: "eur",
  GQ: "xaf", GR: "eur", GS: "gbp", GT: "gtq", GU: "usd", GW: "xof", GY: "gyd", HK: "hkd", HM: "aud", HN: "hnl",
  HR: "eur", HT: "htg", HU: "huf", IC: "eur", ID: "idr", IE: "eur", IL: "ils", IM: "gbp", IN: "inr", IO: "usd",
  IQ: "iqd", IR: "irr", IS: "isk", IT: "eur", JE: "gbp", JM: "jmd", JO: "jod", JP: "jpy", KE: "kes", KG: "kgs",
  KH: "khr", KI: "aud", KM: "kmf", KN: "xcd", KP: "kpw", KR: "krw", KW: "kwd", KY: "kyd", KZ: "kzt", LA: "lak",
  LB: "lbp", LC: "xcd", LI: "chf", LK: "lkr", LR: "lrd", LS: "zar", LT: "eur", LU: "eur", LV: "eur", LY: "lyd",
  MA: "mad", MC: "eur", MD: "mdl", ME: "eur", MF: "eur", MG: "mga", MH: "usd", MK: "mkd", ML: "xof", MM: "mmk",
  MN: "mnt", MO: "mop", MP: "usd", MQ: "eur", MR: "mru", MS: "xcd", MT: "eur", MU: "mur", MV: "mvr", MW: "mwk",
  MX: "mxn", MY: "myr", MZ: "mzn", NA: "zar", NC: "xpf", NE: "xof", NF: "aud", NG: "ngn", NI: "nio", NL: "eur",
  NO: "nok", NP: "npr", NR: "aud", NU: "nzd", NZ: "nzd", OM: "omr", PA: "pab", PE: "pen", PF: "xpf", PG: "pgk",
  PH: "php", PK: "pkr", PL: "pln", PM: "eur", PN: "nzd", PR: "usd", PS: "ils", PT: "eur", PW: "usd", PY: "pyg",
  QA: "qar", RE: "eur", RO: "ron", RS: "rsd", RU: "rub", RW: "rwf", SA: "sar", SB: "sbd", SC: "scr", SD: "sdg",
  SE: "sek", SG: "sgd", SH: "shp", SI: "eur", SJ: "nok", SK: "eur", SL: "sle", SM: "eur", SN: "xof", SO: "sos",
  SR: "srd", SS: "ssp", ST: "stn", SV: "usd", SX: "xcg", SY: "syp", SZ: "szl", TA: "gbp", TC: "usd", TD: "xaf",
  TF: "eur", TG: "xof", TH: "thb", TJ: "tjs", TK: "nzd", TL: "usd", TM: "tmt", TN: "tnd", TO: "top", TR: "try",
  TT: "ttd", TV: "aud", TW: "twd", TZ: "tzs", UA: "uah", UG: "ugx", UM: "usd", US: "usd", UY: "uyu", UZ: "uzs",
  VA: "eur", VC: "xcd", VE: "ves", VG: "usd", VI: "usd", VN: "vnd", VU: "vuv", WF: "xpf", WS: "wst", XK: "eur",
  YE: "yer", YT: "eur", ZA: "zar", ZM: "zmw", ZW: "usd"
});

// Stripe charge amounts use two decimal places unless the currency is listed
// as zero-decimal. ISK and UGX retain Stripe's two-decimal compatibility form.
export const STRIPE_ZERO_DECIMAL_CURRENCIES = new Set([
  "bif", "clp", "djf", "gnf", "jpy", "kmf", "krw", "mga", "pyg", "rwf", "vnd", "vuv", "xaf", "xof", "xpf"
]);

export const normaliseCurrencyCode = (value = "", fallback = "aud") => {
  const currency = String(value || "").trim().toLowerCase();
  if (/^[a-z]{3}$/.test(currency)) return currency;
  const safeFallback = String(fallback || "aud").trim().toLowerCase();
  return /^[a-z]{3}$/.test(safeFallback) ? safeFallback : "aud";
};

export const currencyForCountryCode = (countryCode = "", fallback = "aud") => (
  COUNTRY_CURRENCY[String(countryCode || "").trim().toUpperCase()] || normaliseCurrencyCode(fallback)
);

export const stripeCurrencyExponent = (currency = "aud") => (
  STRIPE_ZERO_DECIMAL_CURRENCIES.has(normaliseCurrencyCode(currency)) ? 0 : 2
);

export const amountToMinorUnits = (amount, currency = "aud") => {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric)) return 0;
  return Math.round(numeric * (10 ** stripeCurrencyExponent(currency)));
};

export const minorUnitsToAmount = (minorUnits, currency = "aud") => {
  const numeric = Number(minorUnits);
  if (!Number.isFinite(numeric)) return 0;
  return numeric / (10 ** stripeCurrencyExponent(currency));
};

export const formatMoney = (amount, currency = "aud", locale) => {
  const safeCurrency = normaliseCurrencyCode(currency);
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency: safeCurrency.toUpperCase() }).format(Number(amount) || 0);
  } catch {
    return `${safeCurrency.toUpperCase()} ${(Number(amount) || 0).toFixed(stripeCurrencyExponent(safeCurrency))}`;
  }
};

export const formatMoneyFromMinorUnits = (minorUnits, currency = "aud", locale) => (
  formatMoney(minorUnitsToAmount(minorUnits, currency), currency, locale)
);
